var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.49254C1.75 12.3234 1.75 18.3021 1.75 18.3021C1.75 18.3021 1.75 18.3021 1.75 18.3021C1.75 19.7921 3.0092 21 4.5625 21H21.4375C22.9908 21 24.25 19.7921 24.25 18.3021V7.85933M1.75 8.49254C1.75 8.02742 1.99978 7.59512 2.41094 7.34861L13 1L23.5332 6.68359C23.976 6.92252 24.25 7.37198 24.25 7.85933M1.75 8.49254C2.3125 8.49254 13 15.1642 13 15.1642L24.25 7.85933",
    stroke: "#81BC3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d3a4d75cce9caab0e135e8faee1ce6df.svg";
export { ForwardRef as ReactComponent };